<template>
  <div>
    <b-table :data="transactions" hoverable>
      <b-table-column
        field="transactions.createdAt"
        label="Data"
        v-slot="props"
      >
        {{
          new Date(props.row.createdAt).toLocaleDateString(
            undefined,
            transactionDateFormat
          )
        }}
      </b-table-column>

      <b-table-column
        field="transactions.store.storeInfo.name"
        label="Loja"
        v-slot="props"
      >
        {{ props.row.store.storeInfo.name }}
      </b-table-column>

      <b-table-column
        field="user.personalInfo.name"
        label="Cliente"
        v-slot="props"
      >
        <column-user-gou
          v-if="props.row.details.origin === 'gou'"
          :user="props.row.user"
        />

        <column-user
          v-else-if="props.row.user"
          :user="props.row.user"
          @open-user-info-modal="openUserInfoModal"
        />

        <p v-else-if="props.row.vending">
          {{ props.row.vending.vendingInfo.name }}
        </p>
      </b-table-column>

      <b-table-column
        field="transactions.cart.totalValue"
        label="Carrinho"
        v-slot="props"
      >
        <button
          class="button is-light"
          slot="trigger"
          @click.stop="openCartModal(props.row)"
        >
          {{ `R$${formatMoney(props.row.cart.totalValue)}` }}
        </button>
      </b-table-column>

      <b-table-column
        field="transactions.paynet.description"
        label="Transação"
        v-slot="props"
      >
        <column-transaction-status :t="props.row" />
      </b-table-column>

      <template slot="empty">
        <table-empty-template />
      </template>
    </b-table>

    <b-modal :active.sync="isUserInfoModalActive" has-modal-card>
      <user-info-modal :user="user" />
    </b-modal>

    <b-modal :active.sync="isCartModalActive" has-modal-card>
      <cart-modal :transaction="transaction" />
    </b-modal>
  </div>
</template>

<script>
import { mask } from "../../../mixins/mask";
import cartModal from "./CartModal";
import userInfoModal from "../../common/UserInfoModal";
import columnTransactionStatus from "./ColumnTransactionStatus";
import columnUser from "./ColumnUser";
import columnUserGou from "./ColumnUserGou";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";

export default {
  props: ["transactions"],

  mixins: [mask],

  components: {
    cartModal,
    userInfoModal,
    columnTransactionStatus,
    columnUser,
    columnUserGou,
    tableEmptyTemplate
  },

  data() {
    return {
      isCartModalActive: false,
      isUserInfoModalActive: false,
      transaction: null,
      user: null,
      transactionDateFormat: {
        year: "2-digit",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
      }
    };
  },

  methods: {
    openCartModal(transaction) {
      this.transaction = transaction;
      this.isCartModalActive = true;
    },

    openUserInfoModal(user) {
      this.user = user;
      this.isUserInfoModalActive = true;
    }
  }
};
</script>
